export default __webpack_public_path__ + "static/media/thumb.2b2b8dcf.png";